"use client";

import { formatPlainDate, type PlainDate } from "@sa-nu/shared-utils/date";

import { CalendarIcon } from "../../dx-icons";

const START_PLACEHOLDER = "チェックイン日";
const END_PLACEHOLDER = "チェックアウト日";

type CombineDateInputProps = {
  startDate: PlainDate | null;
  endDate: PlainDate | null;
};

export function CombineDateInput({
  startDate,
  endDate,
}: CombineDateInputProps) {
  const startValue = startDate
    ? formatPlainDate(startDate, { format: "slash", pad: true })
    : null;
  const endValue =
    startDate && endDate
      ? `${formatPlainDate(endDate, { format: "slash", pad: true })} ${startDate.until(endDate).total({ unit: "day" })}泊`
      : null;
  return (
    <div className="bg-dx-surface-base font-notojp flex shrink-0 items-center gap-[8px] px-[16px] py-[12px] text-[16px] leading-[28px]">
      <CalendarIcon className="text-dx-text-sub" />
      <p>
        <DateOrPlaceholder value={startValue} placeholder={START_PLACEHOLDER} />
        <span className="text-dx-text-default"> - </span>
        <DateOrPlaceholder value={endValue} placeholder={END_PLACEHOLDER} />
      </p>
    </div>
  );
}

function DateOrPlaceholder({
  value,
  placeholder,
}: {
  value: string | null;
  placeholder: string;
}) {
  const style =
    value !== null
      ? "text-dx-text-default font-bold"
      : "text-dx-text-muted font-normal";
  return <span className={style}>{value ?? placeholder}</span>;
}
